
require('./bootstrap');

import $ from 'jquery';
import 'jquery-ui/ui/widgets/sortable.js';
import 'select2';
import 'select2/dist/css/select2.css';

window.$ = window.jQuery = require('jquery');
window.$ = window.jQuery = $;
$('.sortable').sortable();

var dtlanguage_spanish = {
    "sProcessing":     "Procesando...",
                "sLengthMenu":     "Mostrar _MENU_ registros",
                "sZeroRecords":    "No se encontraron resultados",
                "sEmptyTable":     "Ningún dato disponible en esta tabla =(",
                "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
                "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                "sInfoPostFix":    "",
                "sSearch":         "Buscar:",
                "sUrl":            "",
                "sInfoThousands":  ",",
                "sLoadingRecords": "Cargando...",
                "oPaginate": {
                    "sFirst":    "Primero",
                    "sLast":     "Último",
                    "sNext":     "Siguiente",
                    "sPrevious": "Anterior"
                },
                "oAria": {
                    "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                    "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                },
                "buttons": {
                    "copy": "Copiar",
                    "colvis": "Visibilidad"
                }
};

window.bindTimeOutAlerts = function() {
    setTimeout(function() {
        $(".alert").slideUp(1500, function() {
            $(this).alert('close');
        });
    }, 15000);
}

window.bindTimeOutAlerts();